<div #table role="table" (scroll)="handleScroll()">
  <ng-content select="opac-table-row"></ng-content>
</div>
